export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <path
      d="M14 56 V30 a18 18 0 0 1 36 0 V56"
      fill="none"
      stroke="currentColor"
      strokeWidth="3.2"
      strokeLinecap="round"
    />
    <path d="M9 56 H55" stroke="currentColor" strokeWidth="3.2" strokeLinecap="round" />
    <ellipse cx="32" cy="42" rx="6" ry="8.5" fill="#C85A32" />
    <path
      d="M32 34.5 q 4.5 7.5 0 15"
      stroke="#FAF7F2"
      strokeWidth="2.2"
      fill="none"
      strokeLinecap="round"
    />
  </svg>
);

export const Logo = ({ dark = false }) => (
  <span className="flex items-center gap-3">
    <LogoMark className={`h-9 w-9 ${dark ? "text-[#F5F0E6]" : "text-[#1B3B2B]"}`} />
    <span className="flex flex-col leading-none">
      <span
        className={`font-display text-xl font-semibold tracking-tight ${
          dark ? "text-[#F5F0E6]" : "text-[#1B3B2B]"
        }`}
      >
        Café des Arcades
      </span>
      <span className="mt-1 font-mono text-[10px] uppercase tracking-[0.28em] text-[#C85A32]">
        Rennes · Depuis 2018
      </span>
    </span>
  </span>
);
